<template>
    <div>
        <div class="connection-loading-overlay" v-if="connectionLoadingOverlay">
            <div class="text-5xl text-grey-darkest text-center loading-custom" style="position: absolute;top: 45vh;left: 33vw;">
                Connecting Services Please Wait
                <i class="fa fa-spin fa-spinner" aria-hidden="true"></i>
            </div>
        </div>
        <div class="card card-default">
            <div class="card-header">
                <div class="row" v-if="!showErpConnect && (connectedErpIntegration === 'foundation' || connectedErpIntegration === 'vista' || connectedErpIntegration === 'spectrum' || connectedErpIntegration === 'sage-100-contractor' || connectedErpIntegration === 'sage-300-cre' || connectedErpIntegration === 'foundation' || connectedErpIntegration === 'computerEase')">
                    <button class="hover:underline text-teal py-1 px-3" @click.prevent="backToERPConnection">Back</button>
                </div>
                <div v-else class="row">
                    <div class="col-10">ERP Integration Connection</div>
                    <div class="col-2 text-right" v-if="!showErpConnect" @click="closeErpEdit">
                        <i class="fa fa-times-circle-o fa-2x" aria-hidden="true"></i>
                    </div>
                </div>
            </div>
            <div class="card-body" style="background-color: white;">
                <div v-if="allERPLoader">
                    <div class="text-4xl text-grey-darkest text-center loading-custom" style="top: 45vh;left: 50%;">
                        <i class="fa fa-spin fa-spinner" aria-hidden="true"></i>
                    </div>
                </div>
                <div class="contatiner mx-5" v-else-if="showErpConnect">
                    <div v-for="item in connectTabs" class="row mt-3 align-items-center" style="border: 1px solid black;border-radius: 5px;padding: 15px;background-color: white;" v-if="(!disableAllConnect || (disableAllConnect && item.btnText !== 'Connect'))">
                        <div class="col-6">
                            <img style="width: 120px" :src="returnUrl(item.value)">
                        </div>
                        <div class="col-6  text-right">
                            <div v-if="disableAllConnect && item.btnText === 'Connect'">
                                <button type="button" class="btn btn-primary" disabled>
                                    {{ item.btnText }}
                                </button>
                            </div>
                            <div v-else-if="disableAllConnect === false && item.btnText === 'Connect'">
                                <button type="button" class="btn btn-primary" @click.prevent="openModel(item.value)">
                                    {{ item.btnText }}
                                </button>
                            </div>
                            <div v-else>
                                <div v-if="connectedErpIntegration === 'vista' && vistaConnections.length > 0" class="d-inline-flex">

                                    <div class="dropdown mr-1"  v-if="vistaConnections.length > 1">

                                        <button class="btn btn-primary dropdown-toggle standard-dropdown"  id="vistaOptionDropDown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            {{ item.btnText }}
                                        </button>
<!--                                        <div class="standard-dropdown dropdown-menu" aria-labelledby="vistaOptionDropDown">-->
<!--                                            <button v-for="connection in vistaConnections" type="button" class="dropdown-item py-2" @click.prevent.stop="openModel(item.value, item.btnText === 'Settings', connection.id)">-->
<!--                                                {{ connection.linked_company_name }} <i class="fa fa-pencil"></i></button>-->
<!--                                        </div>-->
                                        <div class="standard-dropdown dropdown-menu" aria-labelledby="vistaOptionDropDown" @click.stop>
                                            <div v-for="connection in vistaConnections" :key="connection.id" class="dropdown-item py-2 d-flex align-items-center justify-content-between">

                                                <template v-if="editingConnection === connection.id">
                                                    <div class="d-flex align-items-center w-100">
                                                        <!-- Editable Input Field -->
                                                        <input type="text" v-model="connection.name"
                                                               @click.stop
                                                               @keyup.enter="saveConnection(connection)"
                                                               class="form-control d-inline-block me-2 text-center"
                                                               style="width: 75%; height: 32px;">

                                                        <!-- Save Button with Check Icon (Bigger Size) -->
                                                        <i class="fa fa-check text-success ml-3"
                                                           @click.stop="saveConnection(connection)"
                                                           style="font-size: 20px; cursor: pointer;"></i>
                                                    </div>
                                                </template>

                                                <template v-else>
                                                    <!-- Button that calls openModel only when not editing -->
                                                    <button type="button" class="btn btn-link text-dark d-flex align-items-center hover:no-underline"
                                                            @click.prevent.stop="openModel(item.value, item.btnText === 'Settings', connection)">
                                                        {{ connection.name }}
                                                        <i class="fa fa-pencil ms-2 ml-3" @click.stop="editingConnection = connection.id"></i>
                                                    </button>
                                                </template>

                                            </div>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <button type="button" class="btn btn-primary mr-1"
                                                @click.prevent.stop="openModel(item.value, item.btnText === 'Settings', vistaConnections[0])">
                                            {{ item.btnText }}</button>
                                    </div>

                                    <button v-if="connectedErpIntegration === 'vista'" class="btn btn-outline-primary mr-1 custom-tooltip" @click.prevent="openModel(item.value)" title="Connect another Vista system"><i class="fa fa-plus"></i></button>
                                    <button class="btn btn-outline-danger" @click.prevent="selectVistaConnToDisconnect()"><i class="fa fa-remove"></i></button>
                                </div>
                                <div v-else>
                                    <button type="button" class="btn btn-primary mr-1"
                                            @click.prevent="openModel(item.value, item.btnText === 'Settings')">
                                        {{ item.btnText }}
                                    </button>
                                    <button type="button" class="btn btn-danger"
                                            @click.prevent="disconnectErpIntegration(item.value)" >
                                        Disconnect
                                    </button>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
                <div v-else-if="connectedErpIntegration === 'vista' || connectedErpIntegration === 'spectrum' || connectedErpIntegration === 'foundationNew'"  class="container">
<!--                    <erp-integration-vista-settings :team="team" :bucketUrl="bucketUrl" :connectedErpIntegration="connectedErpIntegration" ></erp-integration-vista-settings>-->
                    <erp-integration-field-settings :team="team" :bucketUrl="bucketUrl" :connectedErpIntegration="connectedErpIntegration" :vistaConnection="vistaConnection" :vistaConnections="vistaConnections"></erp-integration-field-settings>
                </div>
                <div v-else-if="connectedErpIntegration === 'sage-100-contractor'" class="container">
                    <erp-integration-sage100-settings :team="team" :bucketUrl="bucketUrl" :connectedErpIntegration="connectedErpIntegration" ></erp-integration-sage100-settings>
                </div>
                <div v-else-if="connectedErpIntegration === 'sage-300-cre'" class="container">
                    <erp-integration-sage300-settings :team="team" :bucketUrl="bucketUrl" :connectedErpIntegration="connectedErpIntegration" ></erp-integration-sage300-settings>
                </div>
                <div v-else-if="connectedErpIntegration === 'computerEase'"  class="container">
                    <erp-integration-computerEase-field-settings :team="team" :bucketUrl="bucketUrl" :connectedErpIntegration="connectedErpIntegration" ></erp-integration-computerEase-field-settings>
                </div>

               <div v-else class="container">
                    <div class="row">
                        <div class="col-12">
                            <label class="my-4" style="">How will the data flow?</label>
                        </div>

                        <div class="col-md-4 float-left text-center">
                            <img style="width: 150px; margin-top: 35px;" :src="returnUrl('followup')">
                        </div>

                        <div class="col-md-4 float-left text-center">
                            <button type="button"  v-if="modelName === 'sage-intacct'" style="border: 1px solid black;border-radius: 5px;padding: 15px;background-color: white;">
                                    <img v-if="modelName === 'sage-intacct'" style="width: 60px" :src="returnUrl('one-way-third-party')">
                            </button>
                            <button v-else type="button" @click="changeDirection" style="border: 1px solid black;border-radius: 5px;padding: 15px;background-color: white;">
                                    <img style="width: 60px" :src="returnUrl(direction)">
                            </button>
                        </div>
                        <div class="col-md-4 float-left text-center">
                            <img v-if="modelName === 'foundationNew'" style="width: 150px; margin-top: 15px;" :src="returnUrl('foundation')">
                            <img v-if="modelName === 'sage-intacct'" style="width: 150px; margin-top: 25px;" :src="returnUrl('sage-intacct')">
                            <img v-if="modelName === 'sage-300'" style="width: 150px; margin-top: 15px;" :src="returnUrl('sage-300')">
                            <img v-if="modelName === 'sage-100'" style="width: 100px; margin-top: 15px;" :src="returnUrl('sage-100')">
                            <img v-if="modelName === 'vista'" style="width: 150px; margin-top: 15px;" :src="returnUrl('vista')">
                            <img v-if="modelName === 'spectrum'" style="width: 150px; margin-top: 15px;" :src="returnUrl('spectrum')">
                            <img v-if="modelName === 'sage-100-contractor'" style="width: 150px; margin-top: 15px;" :src="returnUrl('sage-100-contractor')">
                            <img v-if="modelName === 'sage-300-cre'" style="width: 150px; margin-top: 15px;" :src="returnUrl('sage-300-cre')">
                            <img v-if="modelName === 'foundation'" style="width: 150px; margin-top: 15px;" :src="returnUrl('foundation')">
                        </div>
                    </div>

                    <div class="row" v-if="modelName !== 'foundationNew' && modelName !== 'sage-intacct'">
                        <div class="col-12">
                            <label class="my-4">What is the source of truth? </label>
                        </div>
                        <b-form-select
                            class="ml-4 col-md-4"
                            v-model="selectedSourceTruth"
                            :options="sourceTruthOptions"
                            value-field="value"
                            text-field="label"
                            @change="updateAllData"
                        ></b-form-select>
                    </div>

                    <div class="row">
                        <div v-if="modelName !== 'sage-intacct'" class="col-12">
                            <label class="my-4">Field Mapping </label>
                        </div>
                        <div v-if="modelName !== 'sage-intacct'" class="col-12" style="">
                            <table class="table table-bordered">
                                <thead>
                                <tr>
                                    <th :col="modelName === 'foundation' ? '2' : '3'"><img style="width: 75px;" :src="returnUrl('followup')"></th>
                                    <th col="2" >Direction</th>
                                    <th :col="modelName === 'foundation' ? '2' : '3'">
                                        <img v-if="modelName === 'foundationNew'" style="width: 75px;" :src="returnUrl('foundation')">
                                        <img v-if="modelName === 'sage-300'" style="width: 75px;" :src="returnUrl('sage-300')">
                                        <img v-if="modelName === 'sage-100'" style="width: 50px;" :src="returnUrl('sage-100')">
                                        <img v-if="modelName === 'vista'" style="width: 75px;" :src="returnUrl('vista')">
                                        <img v-if="modelName === 'spectrum'" style="width: 75px;" :src="returnUrl('spectrum')">
                                        <img v-if="modelName === 'sage-100-contractor'" style="width: 75px;" :src="returnUrl('sage-100-contractor')">
                                        <img v-if="modelName === 'sage-300-cre'" style="width: 75px;" :src="returnUrl('sage-300-cre')">
                                        <img v-if="modelName === 'foundation'" style="width: 150px; margin-top: 15px;" :src="returnUrl('foundation')">
                                    </th>
                                    <th col="2" v-if="modelName === 'foundation'">Import / Export</th>
                                    <th col="2">ON/OFF</th>
                                    <th col="2">Delete</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="item in mappingData" :key="item.id" :id="item.id">
                                    <td>
                                        <div v-if="item.id !== 0">
                                           {{item.followUp.replace("-" , ' ')}}
                                        </div>
                                        <b-form-select
                                            v-else
                                            v-model="item.followUp"
                                            :options="objectOption"
                                            value-field="value"
                                            text-field="label"
                                            disabled-field="disabled"
                                            @change="changeFields(item, 'followup')"
                                        ></b-form-select>
                                    </td>
                                    <td><img  @click="changeDirection"  style="width: 30px" :src="returnUrl(direction)"></td>
                                    <td>
                                        <div v-if="item.id !== 0">
                                            {{item.thirdParty.replace("-",' ')}}
                                        </div>
                                        <b-form-select
                                            v-else
                                            v-model="item.thirdParty"
                                            :options="objectOption"
                                            value-field="value"
                                            text-field="label"
                                            disabled-field="disabled"
                                            @change="changeFields(item, 'thirdParty')"
                                        ></b-form-select>
                                    </td>
                                    <td v-if="modelName === 'foundation'">
                                        <div v-if="direction !== 'one-way-third-party' && item.followUp === 'Companies'">
                                            <button type="button" class="btn btn-primary form-control" @click="importFoundationData">Import From Foundation</button>
                                        </div>
<!--                                        <div v-else-if="direction !== 'one-way-followup' && item.followUp === 'Project'">-->
<!--                                           <button type="button" class="btn btn-primary form-control" @click="exportDataToFoundation">Export to Foundation</button>-->
<!--                                       </div>-->
                                    </td>
                                    <td><b-form-checkbox v-model="item.status" switch @change="updateFieldStatus(item)"></b-form-checkbox></td>
                                    <td>
                                        <button v-if="item.id !== 0" type="button" class="btn btn-danger"
                                                @click.prevent="deleteMappingData(item)">
                                            <i class="fa fa-trash-o" aria-hidden="true"></i>
                                        </button>

                                        <button v-else type="button" class="btn btn-primary"
                                                @click.prevent="createFields(item)">
                                            Add
                                        </button>
                                    </td>
                                </tr>
                                <tr v-if="showButtonMapping && mappingData.length < 3">
                                    <td :colspan="modelName === 'foundation' ? '5' : '4'"></td>
                                    <td>
                                        <button type="button" class="btn btn-primary"
                                                @click.prevent="addMapData()">
                                            Add Mapping
                                        </button>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div v-if="modelName !== 'sage-intacct'" class="col-12">
                            <div :class="(modelName === 'foundation') ? 'd-flex justify-content-between align-items-center justify-content-center' : 'row float-right mr-0'">
                                <div v-if="modelName === 'foundation'" class="d-flex justify-content-center">
                                    <div>
                                        <input type="checkbox" v-model="allowPushContactOnCreateUpdate">
                                    </div>
                                    <div>
                                        <p class="text-grey-darkest px-1">Do not push companies/contacts to Foundation on create.</p>
                                    </div>
                                </div>
                                <div>
                                    <button type="button" class="btn btn-primary"
                                            @click.prevent="clickSyncButton(modelName)">
                                        Sync
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div v-else class="col-12">
                            <hr>
                            <div :class="(sageIntacctLocations.length > 0) ? 'd-flex justify-content-between align-items-center justify-content-center' : 'row float-right mr-0'">
                                <div v-if="sageIntacctLocations.length > 0" class="d-flex justify-content-center">
                                    <div>
                                        <select name="sage_intacct_location_id" id="sage_intacct_location_id"
                                                class="appearance-none p-1 bg-white border-1 focus:outline-none rounded text-grey-darkest"
                                                v-model="sage_intacct_location_id" @change="changeSageIntacctLocation($event)">
                                            <option selected value="">Top Level</option>
                                            <option v-for="item in sageIntacctLocations" :value="item.location_id">{{ item.entity }}
                                            </option>
                                        </select>
                                    </div>
                                    <div>
                                        <p class="text-grey-darkest px-1">Sage Intacct Locations</p>
                                    </div>
                                </div>
                                <div>
                                    <button type="button" class="btn btn-primary"
                                            @click.prevent="clickSyncButton(modelName)">
                                        Sync
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <b-modal id="modelName-model modal-xl" size="lg" title="modelName" :hide-footer="true" :hide-header="true" v-model="showDataformaModal">
            <div class="container">
                <h3 class="text-center my-4">ERP Integration </h3>
                <div class="row">
                    <div class="col-md-4 float-left text-center">
                        <img style="width: 150px; margin-top: 35px;" :src="returnUrl('followup')">
                    </div>
                    <div class="col-md-4 float-left text-center">
                        <img style="width: 120px" :src="returnUrl('cloud')">
                    </div>
                    <div class="col-md-4 float-left text-center">
                        <img v-if="modelName === 'foundationNew'" style="width: 150px; margin-top: 25px;" :src="returnUrl('foundation')">
                        <img v-if="modelName === 'sage-intacct'" style="width: 150px; margin-top: 25px;" :src="returnUrl('sage-intacct')">
                        <img v-if="modelName === 'sage-300'" style="width: 150px; margin-top: 25px;" :src="returnUrl('sage-300')">
                        <img v-if="modelName === 'sage-100'" style="width: 100px; margin-top: 25px;" :src="returnUrl('sage-100')">
                        <img v-if="modelName === 'vista'" style="width: 150px; margin-top: 25px;" :src="returnUrl('vista')">
                        <img v-if="modelName === 'spectrum'" style="width: 150px; margin-top: 25px;" :src="returnUrl('spectrum')">
                        <img v-if="modelName === 'sage-100-contractor'" style="width: 150px; margin-top: 25px;" :src="returnUrl('sage-100-contractor')">
                        <img v-if="modelName === 'sage-300-cre'" style="width: 150px; margin-top: 25px;" :src="returnUrl('sage-300-cre')">
                        <img v-if="modelName === 'foundation'" style="width: 150px; margin-top: 25px;" :src="returnUrl('foundation')">
                    </div>
                </div>
                <h5 class="text-center my-5">Cost $250/M please reach out to your <br/>
                    account manager to add to your plan </h5>
            </div>
        </b-modal>
        <b-modal no-close-on-backdrop id="sync-model modal-xl" size="lg" title="SyncModel" :hide-footer="true" v-model="showSyncModal" @hidden="closeSyncModel">
            <div class="container">
                <h3 class="text-center my-4">Syncing in progress</h3>
                <div class="row">
                    <div class="col-md-4 float-left text-center">
                        <img style="width: 150px; margin-top: 35px;" :src="returnUrl('followup')">
                    </div>
                    <div class="col-md-4 float-left text-center">
                        <img style="width: 120px" :src="returnUrl('cloud')">
                    </div>
                    <div class="col-md-4 float-left text-center">
                        <img v-if="modelName === 'foundationNew'" style="width: 150px; margin-top: 25px;" :src="returnUrl('foundation')">
                        <img v-if="modelName === 'sage-intacct'" style="width: 150px; margin-top: 25px;" :src="returnUrl('sage-intacct')">
                        <img v-if="modelName === 'sage-300'" style="width: 150px; margin-top: 25px;" :src="returnUrl('sage-300')">
                        <img v-if="modelName === 'sage-100'" style="width: 100px; margin-top: 25px;" :src="returnUrl('sage-100')">
                        <img v-if="modelName === 'vista'" style="width: 150px; margin-top: 25px;" :src="returnUrl('vista')">
                        <img v-if="modelName === 'spectrum'" style="width: 150px; margin-top: 25px;" :src="returnUrl('spectrum')">
                        <img v-if="modelName === 'sage-100-contractor'" style="width: 150px; margin-top: 25px;" :src="returnUrl('sage-100-contractor')">
                        <img v-if="modelName === 'sage-300-cre'" style="width: 150px; margin-top: 25px;" :src="returnUrl('sage-300-cre')">
                        <img v-if="modelName === 'foundation'" style="width: 150px; margin-top: 25px;" :src="returnUrl('foundation')">
                    </div>
                </div>
                <h5 v-if="syncFoundationContractMsg()">{{ contractMsg }}</h5>
                <h5 class="text-center my-5">Please check in few hours</h5>
            </div>
        </b-modal>

        <b-modal no-close-on-backdrop id="import-model modal-xl" size="lg" :title="importModalTitle" :hide-footer="true" v-model="showImportModal" @hidden="closeImportModal">
            <div class="container">
                <h3 class="text-center my-4">{{ importModalMsg }}</h3>
                <div class="row">
                    <div class="col-md-4 float-left text-center">
                        <img style="width: 150px; margin-top: 35px;" :src="returnUrl('followup')">
                    </div>
                    <div class="col-md-4 float-left text-center">
                        <img style="width: 120px" :src="returnUrl('cloud')">
                    </div>
                    <div class="col-md-4 float-left text-center">
                        <img v-if="modelName === 'foundationNew'" style="width: 150px; margin-top: 25px;" :src="returnUrl('foundation')">
                        <img v-if="modelName === 'sage-intacct'" style="width: 150px; margin-top: 25px;" :src="returnUrl('sage-intacct')">
                        <img v-if="modelName === 'sage-300'" style="width: 150px; margin-top: 25px;" :src="returnUrl('sage-300')">
                        <img v-if="modelName === 'sage-100'" style="width: 100px; margin-top: 25px;" :src="returnUrl('sage-100')">
                        <img v-if="modelName === 'vista'" style="width: 150px; margin-top: 25px;" :src="returnUrl('vista')">
                        <img v-if="modelName === 'spectrum'" style="width: 150px; margin-top: 25px;" :src="returnUrl('spectrum')">
                        <img v-if="modelName === 'sage-100-contractor'" style="width: 150px; margin-top: 25px;" :src="returnUrl('sage-100-contractor')">
                        <img v-if="modelName === 'sage-300-cre'" style="width: 150px; margin-top: 25px;" :src="returnUrl('sage-300-cre')">
                        <img v-if="modelName === 'foundation'" style="width: 150px; margin-top: 25px;" :src="returnUrl('foundation')">
                    </div>
                </div>
                <h5 v-if="syncFoundationContractMsg()">{{ contractMsg }}</h5>
                <h5 class="text-center my-5">Please check in few minutes</h5>
            </div>
        </b-modal>

        <b-modal no-close-on-backdrop id="foundation-connection-detail modal-xl" size="lg" title="Foundation Connection Detail" :hide-footer="true" v-model="foundationConnectionDetailModal" @hidden="closeFoundationConnectionDetailModal()">
            <div class="container">
                <div class="row">
                    <div class="col-12 form-group">
                        <label for="">Database Name <small class="text-danger">*</small></label>
                        <input type="text" class="form-control" v-model="foundationConnectionDetail.databaseName">
                    </div>

                    <div class="col-12 form-group">
                        <label for="">Username <small class="text-danger">*</small></label>
                        <input type="text" class="form-control" v-model="foundationConnectionDetail.username">
                    </div>

                    <div class="col-12 form-group">
                        <label for="">Password <small class="text-danger">*</small></label>
                        <input type="password" class="form-control" v-model="foundationConnectionDetail.password">
                    </div>

                    <div class="col-12 form-group">
                        <label for="">Database Host (On-premises)</label>
                        <input type="text" class="form-control" v-model="foundationConnectionDetail.databaseHost">
                    </div>

                    <div class="col-12 form-group">
                        <label for="">Database Port (On-premises)</label>
                        <input type="text" class="form-control" v-model="foundationConnectionDetail.databasePort">
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 py-2">
                        <div class="row">
                            <div class="col-6">
                                <div class="float-left d-flex flex-row" style="align-items: baseline; font-size: 15px;" v-if="syncFoundationContractMsg()">
<!--                                    <input type="checkbox" v-model="foundationConnectionDetail.syncCheck">-->
<!--                                    <span>Sync all old files with the status “Contract” (Applicable to 2-way sync or one way sync from FollowUp to Foundation)</span>-->
                                </div>
                            </div>
                            <div class="col-6">
                                <button class="btn btn-primary float-right" @click="saveFoundationConnectionDetail()">
                                    <i v-if="foundationSyncLoader" class="fa fa-spin fa-spinner text-grey-darkest" aria-hidden="true"></i> Save Changes
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>

        <b-modal no-close-on-backdrop id="sage-intacct-connection-detail modal-xl" size="lg" title="Sage Intacct Connection Detail" :hide-footer="true" v-model="sageIntacctConnectionDetailModal" @hidden="closeSageIntacctConnectionDetailModal()">
            <div class="container">
                <div class="row">
                    <div class="col-12 form-group">
                        <label for="">Company ID <small class="text-danger">*</small></label>
                        <input type="text" autocomplete="nope" class="form-control" v-model="sageIntacctConnectionDetail.company_id">
                    </div>

                    <div class="col-12 form-group">
                        <label for="">User ID <small class="text-danger">*</small></label>
                        <input type="text" autocomplete="nope" class="form-control" v-model="sageIntacctConnectionDetail.user_id">
                    </div>

                    <div class="col-12 form-group">
                        <label for="">User Password <small class="text-danger">*</small></label>
                        <input type="password" autocomplete="nope" class="form-control" v-model="sageIntacctConnectionDetail.user_password">
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 py-2">
                        <div class="row">
                            <div class="col-6">
<!--                                <div class="float-left d-flex flex-row" style="align-items: baseline; font-size: 15px;" v-if="syncFoundationContractMsg()">-->
<!--&lt;!&ndash;                                    <input type="checkbox" v-model="foundationConnectionDetail.syncCheck">&ndash;&gt;-->
<!--&lt;!&ndash;                                    <span>Sync all old files with the status “Contract” (Applicable to 2-way sync or one way sync from FollowUp to Foundation)</span>&ndash;&gt;-->
<!--                                </div>-->
                            </div>
                            <div class="col-6">
                                <button class="btn btn-primary float-right" @click="saveSageIntacctConnectionDetail()">
                                    <i v-if="foundationSyncLoader" class="fa fa-spin fa-spinner text-grey-darkest" aria-hidden="true"></i> Save Changes
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>

        <b-modal no-close-on-backdrop id="computerEase-connection-detail" size="lg" title="ComputerEase API Details" :hide-footer="true" v-model="computerEaseConnectionDetailModal" @hidden="closeComputerEaseConnectionDetailModal()">
            <div class="container">
                <div class="row">
                    <div class="col-12 form-group">
                        <label for="">API Key <small class="text-danger">*</small></label>
                        <input type="text" autocomplete="nope" class="form-control" v-model="computerEaseConnectionDetail.api_key">
                    </div>

                    <div class="col-12 form-group">
                        <label for="">Refresh Token <small class="text-danger">*</small></label>
                        <input type="text" autocomplete="nope" class="form-control" v-model="computerEaseConnectionDetail.refresh_token">
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 py-2">
                        <div class="row">
                            <div class="col-6">
                            </div>
                            <div class="col-6">
                                <button class="btn btn-primary float-right" @click="saveComputerEaseConnectionDetail()">
                                    <i v-if="foundationSyncLoader" class="fa fa-spin fa-spinner text-grey-darkest" aria-hidden="true"></i> Save
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>

<!--        <b-modal no-close-on-backdrop id="vistaConnectionDisconnectModal" size="lg" title="Vista Disconnect Connection" :hide-footer="true" v-model="vistaDisconnectModal" @hidden="closeComputerEaseConnectionDetailModal()">
            <div class="container">
                <div class="row">
                    <div class="col-12 form-group">
                        <label for="">API Key <small class="text-danger">*</small></label>
                        <input type="text" autocomplete="nope" class="form-control" v-model="computerEaseConnectionDetail.api_key">
                    </div>

                    <div class="col-12 form-group">
                        <label for="">Refresh Token <small class="text-danger">*</small></label>
                        <input type="text" autocomplete="nope" class="form-control" v-model="computerEaseConnectionDetail.refresh_token">
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 py-2">
                        <div class="row">
                            <div class="col-6">
                            </div>
                            <div class="col-6">
                                <button class="btn btn-primary float-right" @click="saveComputerEaseConnectionDetail()">
                                    <i v-if="foundationSyncLoader" class="fa fa-spin fa-spinner text-grey-darkest" aria-hidden="true"></i> Save
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>-->
        <b-modal
            id="vistaConnectionDisconnectModal"
            size="lg"
            title="Select Vista Connections to Disconnect"
            v-model="vistaDisconnectModal"
            no-close-on-backdrop
            :hide-footer="true"
        >
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <h5>Select Connections:</h5>
                        <div v-for="conn in vistaConnections" :key="conn.id" class="form-check">
                            <input
                                type="checkbox"
                                class="form-check-input"
                                :id="'conn-'+conn.id"
                                :value="conn.id"
                                v-model="selectedConnectionToDisconnect"
                            />
                            <label class="form-check-label" :for="'conn-'+conn.id">
                                {{ conn.name }}
                            </label>
                        </div>
                    </div>
                </div>

                <div class="row mt-3">
                    <div class="col-12 text-right">
                        <button class="btn btn-secondary mr-2" @click="vistaDisconnectModal = false">Cancel</button>
                        <button class="btn btn-primary" @click="proceedWithVistaDisconnection">Next</button>
                    </div>
                </div>
            </div>
        </b-modal>

    </div>
</template>


<script>

import axios from 'axios';
import Swal from "sweetalert2";
// import ErpIntegrationVistaSettings from "./erp-integration-vista-setting.vue";
import ErpIntegrationFieldSettings from "./erp-integration-field-setting.vue";
import ErpIntegrationSage100Settings from "./erp-integration-sage100-setting.vue";
import ErpIntegrationSage300Settings from "./erp-integration-sage300-setting.vue";
import ErpIntegrationComputerEaseFieldSettings from "./erp-integration-computerEase-field-setting.vue";

export default {

    name: 'erp-integration',
    components: {
        ErpIntegrationComputerEaseFieldSettings,
        ErpIntegrationFieldSettings,ErpIntegrationSage100Settings,ErpIntegrationSage300Settings},
    props: ['team', 'bucketUrl'],
    data() {
        return {
            showSyncModal:false,
            erpIntegrationId:0,
            direction:'two-ways',
            selectedSourceTruth:null,
            modelName: '',
            showDataformaModal: false,
            showButtonMapping: true,
            showErpConnect: true,
            syncStatus: false,
            mappingData: [],
            sourceTruthOptions:[
                {value:'follow-up', label:'Followup CRM'}
            ],
            objectOption:[
                {value:'Project', label:'Project', disabled: false},
                {value:'Companies', label:'Companies', disabled: false},
                {value:'Contract-type', label:'Contract type', disabled: false}
            ],
            connectButton:{
                foundationNew:'Connect',
                sage300:'Connect',
                sage100:'Connect',
                vista:'Connect',
                spectrum:'Connect',
                foundation:'Connect'
            },
            connectTabs:[
                {
                    name: 'Foundation',
                    value: 'foundation',
                    btnText: 'Connect'
                },
                {
                    name: 'SageIntacct',
                    value: 'sage-intacct',
                    btnText: 'Connect'
                },
                // {
                //     name: 'Sage300',
                //     value: 'sage-300',
                //     btnText: 'Connect'
                // },
                {
                    name: 'Sage 300 CRE',
                    value: 'sage-300-cre',
                    btnText: 'Connect'
                },
                {
                    name: 'Sage 100 Contrator',
                    value: 'sage-100-contractor',
                    btnText: 'Connect'
                },
                // {
                //     name: 'Sage100',
                //     value: 'sage-100',
                //     btnText: 'Connect'
                // },
                {
                    name: 'Vista',
                    value: 'vista',
                    btnText: 'Connect'
                },
                {
                    name: 'Spectrum',
                    value: 'spectrum',
                    btnText: 'Connect'
                },
                {
                    name: 'FoundationNew',
                    value: 'foundationNew',
                    btnText: 'Connect'
                },
                {
                    name: 'ComputerEase',
                    value: 'computerEase',
                    btnText: 'Connect'
                },
            ],

            disableAllConnect:false,
            foundationConnectionDetailModal: false,
            sageIntacctConnectionDetailModal: false,
            foundationConnectionDetail: {
                databaseHost: null,
                databasePort: null,
                databaseName: null,
                username: null,
                password: null,
                syncCheck: false,
            },
            sageIntacctConnectionDetail: {
                company_id: null,
                user_id: null,
                user_password: null,
            },
            sageIntacctLocations:[],
            sage_intacct_location_id:'',
            foundationSyncLoader: false,
            contractMsg: '',
            showImportModal: false,
            importModalMsg: '',
            importModalTitle: '',
            allowPushContactOnCreateUpdate: false,
            connectionLoadingOverlay: false,
            connectedErpIntegration: null,
            allERPLoader: false,
            computerEaseConnectionDetailModal: false,
            computerEaseConnectionDetail: {
                api_key: null,
                refresh_token: null,
            },
            vistaConnections: [],
            vistaConnection: null,
            editingConnection: null,
            agaveConnectionIdsToDisconnect: [],
            selectedConnectionToDisconnect: [],
            vistaDisconnectModal: false,
        };
    },
    watch: {
        'allowPushContactOnCreateUpdate': function (value) {
            let self = this;
            self.mappingData.map(val => {
                if(val.followUp === 'Companies') {
                    self.updateAllowPushFoundation(val);
                }
            })
        }
    },
    async mounted() {
        await this.getAllErp();
        if(this.team.foundation_db_connection_detail !== null) {
            this.foundationConnectionDetail = JSON.parse(this.team.foundation_db_connection_detail);
        }
        if(this.team.sage_intacct_connection_detail !== null) {
            this.sageIntacctConnectionDetail = JSON.parse(this.team.sage_intacct_connection_detail);
        }
        if(this.team.sage_intacct_selected_location !== null) {
            this.sage_intacct_location_id = this.team.sage_intacct_selected_location;
        }

        let agaveScript = document.createElement("script");
        agaveScript.setAttribute("src", "https://app.agaveapi.com/init.js");
        document.head.appendChild(agaveScript);

        $(document).ready(function() {
            $('.custom-tooltip').tooltip();
        });
        // Todo delete once done
        // this.showErpConnect = false;
    },

    methods: {
        saveConnection(connection) {
            this.editingConnection = null; // Hide input field after saving
            try {
                axios.post(route('api.erp-integration.update-connection'), connection).then(({data}) => {
                    if(data && data.id){
                        const index = this.vistaConnections.findIndex(conn => conn.id === connection.id);
                        if (index !== -1) {
                            this.vistaConnections[index] = { ...this.vistaConnections[index], ...data };
                        }
                    }
                });

            } catch (error) {
                console.error("Error saving connection:", error);
            }
        },
        async closeErpEdit(){
            await this.getAllErp();
            this.showErpConnect = true;
            this.showButtonMapping = true;
            this.sourceTruthOptions.splice(1, 1);
        },
        clickSyncButton(modelName){
            if(modelName === 'foundation'){
                this.openFoundationConnectionDetailModal();
            }else if(modelName === 'sage-intacct'){
                this.openSageIntacctConnectionDetailModal();
            } else {
                this.openSyncModel();
            }
        },
        async openSyncModel(){
            this.showSyncModal =  true;
            this.syncStatus = true;
            let self = this;
            let payload =  {
                    erpIntegrationId : self.erpIntegrationId
                }
            await axios.post(route('api.erp-integration.sync'), payload).then(async ({data}) => {
                await this.updateAllData();
            });

        },

        async closeSyncModel(){
            this.showSyncModal =  false;
            this.showErpConnect = true;
            this.sourceTruthOptions.splice(1, 1);
            this.showButtonMapping = true;
            await this.getAllErp();
        },

        async openModel(name, showVistaSettings =  false, connection = null) {

            this.modelName = name;
            let self = this;

            if (this.team.plan_id && this.team.has_erp_integration_access === 1 ) {
                if(self.modelName == 'vista' || self.modelName == 'spectrum'){
                    if(showVistaSettings){
                        this.showErpConnect = false;
                        this.vistaConnection = connection;
                    }else{
                        this.generateVistaLinkToken();
                    }
                }else if(self.modelName == 'sage-100-contractor'){
                    if(showVistaSettings){      //erp settings/mapping page
                        this.showErpConnect = false;
                    }else{
                        this.generateVistaLinkToken();
                    }
				}else if(name == 'sage-300-cre'){
	                if(showVistaSettings){
	                    this.showErpConnect = false;
	                }else{
	                    this.generateVistaLinkToken();
	                }
                }else if(name == 'foundationNew'){
                    if(showVistaSettings){
                        this.showErpConnect = false;
                    }else{
                        this.generateVistaLinkToken();
                    }
                  /*  this.showErpConnect = false;
                    this.sourceTruthOptions.push({value:name, label:name});
                    this.selectedSourceTruth = name;
                    await this.getErpIntegrations();
                    await this.updateAllData();
                    if(self.modelName === 'foundation') {
                        self.objectOption = _.filter(self.objectOption, function(item) { return item.value !== 'Contract-type' });
                    }*/
                }
                else if(name === 'sage-intacct'){
                    this.showErpConnect = false;
                    this.sourceTruthOptions.push({value:name, label:name});
                    this.selectedSourceTruth = name;
                    await this.getErpIntegrations();
                    await this.updateAllData();
                }
                else if(name == 'foundation'){
                    this.showErpConnect = false;
                    this.sourceTruthOptions.push({value:name, label:name});
                    this.selectedSourceTruth = name;
                    await this.getErpIntegrations();
                    await this.updateAllData();
                    if(self.modelName === 'foundation') {
                        self.objectOption = _.filter(self.objectOption, function(item) { return item.value !== 'Contract-type' });
                    }
                }else if(name === 'computerEase'){
                    if(showVistaSettings){
                        this.showErpConnect = false;
                    }else{
                        this.computerEaseConnectionDetailModal =  true;
                    }
                }
                else{

                }

            }else {
                this.showDataformaModal = true;
            }
        },

        async addMapData() {
            const self = this;
            await self.disabledOption(self.mappingData)
            const result = await self.objectOption.filter(val => val.disabled !== true);
            if(result.length > 0){
                await self.mappingData.push({
                    erp_integration_id: self.erpIntegrationId,
                    id: 0,
                    followUp: result[0].value,
                    direction: this.direction,
                    thirdParty: result[0].value,
                    status: true
                })
            }
            self.showButtonMapping = false;
        },

        createFields(data) {
            const self = this;
            let payload =  {
                    erp_integration_id : this.erpIntegrationId,
                    data:data
                }
            axios.post(route('api.erp-integration-fields.create'), payload).then(({data}) => {
                self.getErpIntegrations();
                this.showButtonMapping = true;
            });
        },

        async deleteMappingData(item) {
            let self = this;
            let payload =  {
                    erp_integration_id : this.erpIntegrationId,
                    field_id : item.id
                }
            await axios.post(route('api.erp-integration-fields.delete'), payload).then(async ({data}) => {
                await self.getErpIntegrations();
                await this.getAllErp();
                self.showButtonMapping = true;
                const objectOptionIndex = this.objectOption.findIndex(val => val.value === item.followUp);
                if(objectOptionIndex !== -1){
                    this.objectOption[objectOptionIndex].disabled = false;
                }
            });
        },

        returnUrl(val){
            if(val === 'foundationNew'){
                val = 'foundation';
            }
            return this.bucketUrl+'erp/'+val+'.png'
        },

        changeDirection(){
            switch (this.direction) {
                case 'two-ways':
                    this.direction = 'one-way-followup';
                    break;
                case 'one-way-followup':
                    this.direction = 'one-way-third-party';
                    break;
                case 'one-way-third-party':
                    this.direction = 'two-ways';
                    break;
                default:
                    console.log(`Sorry, we are out`);
            }
            this.updateAllData();
            this.showButtonMapping = true;
        },

        updateAllData(){
            const self = this;
            let payload =  {
                    third_party_name : this.modelName,
                    direction : this.direction,
                    source_truth : this.selectedSourceTruth,
                    sync_status : this.syncStatus
                }
            axios.post(route('api.erp-integration.update'), payload).then(({data}) => {
                self.erpIntegrationId = data.id;
                self.getErpIntegrations();
            });
        },

        updateFieldStatus(item){
            const self = this;
            let payload =  {
                    status : !item.status,
                    erp_integration_field_id : item.id,
                    erp_integration_id : item.erp_integration_id,
                }
                if(item.id == 0){
                    return false
                }
            axios.post(route('api.erp-integration-fields.update'), payload).then(({data}) => {
            });
        },
        updateAllowPushFoundation(item){
            const self = this;
            let payload =  {
                erp_integration_field_id : item.id,
                erp_integration_id : item.erp_integration_id,
                allow_push_on_create_update: !self.allowPushContactOnCreateUpdate
            }
            if(item.id == 0){
                return false
            }
            axios.post(route('api.erp-integration-fields.update-allow-push-foundation'), payload).then(({data}) => {
            });
        },
        async getErpIntegrations(){
            const self = this;
            await axios.get(route('api.erp-integration.get',{third_party_name: self.modelName})).then( async ({data}) => {
                if(data){
                    self.erpIntegrationId = data.id;
                    self.direction = data.direction
                    self.selectedSourceTruth = data.source_truth
                    self.syncStatus = data.sync_status
                    self.mappingData = await data.fields.map(val => {
                        if(val.follow_up_object === 'Companies') {
                            self.allowPushContactOnCreateUpdate = !val.allow_push_on_create_update;
                        }
                        return {
                            erp_integration_id: val.erp_integration_id,
                            id: val.id,
                            followUp: val.follow_up_object,
                            direction: val.direction,
                            thirdParty: val.third_party_object,
                            status: val.status ? true : false
                        }
                    })
                    await self.disabledOption(data.fields)
                }

            });
        },

        async getAllErp(){
            const self = this;
            self.allERPLoader = true;
            await axios.get(route('api.all-erp-integration.get')).then( ({data}) => {
                console.log('data', data);
                for (let i = 0; i < data.length; i++) {
                    switch (data[i].third_party_name) {
                        case 'foundationNew':
                            /*if(data[i].fields.length > 0){
                                this.changeBtnText(data[i].third_party_name);
                                this.disableAllConnect =  true
                            }else{
                                this.disconnectAll()
                            }*/
                            if(data){
                                this.changeBtnText(data[i].third_party_name);
                                this.disableAllConnect =  true
                            }else{
                                this.disconnectAll()
                            }
                            break;
                        case 'sage-intacct':
                            // if(data[i].fields.length > 0){
                            this.changeBtnText(data[i].third_party_name);
                            this.disableAllConnect =  true
                            if (data[i].sage_intacct_locations){
                                this.sageIntacctLocations = JSON.parse(data[i].sage_intacct_locations);
                            }
                            // }else{
                            //     this.disconnectAll()
                            // }
                            break;
                        case 'sage-300':
                            if(data[i].fields.length > 0){
                                this.changeBtnText(data[i].third_party_name);
                                this.disableAllConnect =  true
                            }else{
                                this.disconnectAll()
                            }
                            break;
                        case 'sage-100':
                            if(data[i].fields.length > 0){
                                // this.changeBtnText(data[i].third_party_name);
                                // this.disableAllConnect =  true
                                this.disconnectAll()
                            }else{
                                this.disconnectAll()
                            }
                            break;
                        case 'vista':
                            if(data){
                                this.changeBtnText(data[i].third_party_name);
                                this.disableAllConnect =  true
                            }else{
                                this.disconnectAll()
                            }
                            if(data[i]?.agave_connection){
                                this.vistaConnections.push({...data[i]?.agave_connection})
                            }
                            break;
                        case 'spectrum':
                            if(data){
                                this.changeBtnText(data[i].third_party_name);
                                this.disableAllConnect =  true
                            }else{
                                this.disconnectAll()
                            }
                            break;
                        case 'sage-100-contractor':
                            if(data){
                                this.changeBtnText(data[i].third_party_name);
                                this.disableAllConnect =  true
                            }else{
                                this.disconnectAll()
                            }
                            break;
                        case 'sage-300-cre':
                            if(data){
                                this.changeBtnText(data[i].third_party_name);
                                this.disableAllConnect =  true
                            }else{
                                this.disconnectAll()
                            }
                            break;
                        case 'foundation':
                            if(data[i].fields.length > 0){
                                this.changeBtnText(data[i].third_party_name);
                              //  this.disableAllConnect =  true
                            }else{
                                this.disconnectAll()
                            }
                            break;
                        case 'computerEase':
                            if(data){
                                this.changeBtnText(data[i].third_party_name);
                                this.disableAllConnect =  true
                            }else{
                                this.disconnectAll()
                            }
                            break;
                        default:
                            this.disableAllConnect =  false
                    }
                }
                if(data.length == 0){
                    this.disconnectAll()
                }else{
                    this.connectedErpIntegration = data[0].third_party_name;
                }
                self.allERPLoader = false;
            }).catch((error) => {
                self.allERPLoader = false;
            });
        },

        disconnectAll(){

            this.connectTabs.map(val => {
                return val.btnText = 'Connect';
            });
            this.disableAllConnect =  false
        },

        disabledOption(data){
            for (let j = 0; j < data.length; j++) {
                const objectOptionIndex = this.objectOption.findIndex(item => item.value === data[j].followUp);
                if(objectOptionIndex !== -1){
                    this.objectOption[objectOptionIndex].disabled = true;
                }
            }
        },

        changeFields(data, val){

            for (let i = 0; i < this.mappingData.length; i++) {
                if(this.mappingData[i].id === data.id){
                    if(val === 'followup'){
                        this.mappingData[i].thirdParty = data.followUp
                    }else{
                        this.mappingData[i].followUp = data.thirdParty
                    }

                }
            }
        },

        async disconnectErpIntegration(name) {
            let self = this;
            let payload =  {
                third_party_name : name,
                agaveConnectionIds : self.agaveConnectionIdsToDisconnect ?? null
            };
            console.log("disconnect erp integration", payload)

            const swalResult = await Swal.fire({
                title: 'Warning',
                text: "Disconnecting will result in the loss of all the records of sync logs for this instance. Cancel to download a copy in the Sync Logs section of the settings before disconnection",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#01B1AF',
                confirmButtonText: 'Yes, continue'
            });

            if(swalResult.value) {
                await axios.post(route('api.erp-integration.disconnect'), payload).then(async ({data}) => {
                    await self.getAllErp();
                    if(name === 'sage-intacct') {
                        self.sageIntacctConnectionDetail ={
                            company_id: null,
                            user_id: null,
                            user_password: null,
                        }
                        self.sageIntacctLocations = [];
                        self.sage_intacct_location_id = '';
                    }
                    self.getToast(3000).fire({
                        type: 'success',
                        title: 'ERP integration disconnect'
                    });
                    setTimeout(() => {
                        window.location.reload();
                    }, 3000)
                });
            }
        },
        async selectVistaConnToDisconnect() {
            let self = this;

            if (self.vistaConnections.length > 1) {
                self.selectedConnectionToDisconnect = [];
                self.vistaDisconnectModal = true;
            } else {
                self.agaveConnectionIdsToDisconnect = [self.vistaConnections[0].id];
                await self.disconnectErpIntegration('vista');
            }
        },
        proceedWithVistaDisconnection() {
            let self = this;

            if (self.selectedConnectionToDisconnect.length === 0) {
                self.getToast(3000).fire({
                    icon: 'error',
                    title: 'Please select connections to disconnect'
                });
                return;
            }

            self.agaveConnectionIdsToDisconnect = self.selectedConnectionToDisconnect;
            self.vistaDisconnectModal = false;
            self.disconnectErpIntegration('vista');
        },
        changeBtnText(data){
            const objectOptionIndex = this.connectTabs.findIndex(val => val.value === data);
            if(objectOptionIndex !== -1){
                if(data && (data ==='vista' || data === 'spectrum' || data === 'sage-100-contractor' || data === 'sage-300-cre' || data ==='foundationNew' || data ==='foundation' || data === 'computerEase')){
                    this.connectTabs[objectOptionIndex].btnText = 'Settings';
                }else{
                    this.connectTabs[objectOptionIndex].btnText = 'Edit';
                }
            }
        },

        openFoundationConnectionDetailModal() {
            this.foundationConnectionDetailModal =  true;
        },

        closeFoundationConnectionDetailModal() {
            this.foundationConnectionDetailModal =  false;
        },
        openSageIntacctConnectionDetailModal() {
            this.sageIntacctConnectionDetailModal =  true;
        },

        closeSageIntacctConnectionDetailModal() {
            this.sageIntacctConnectionDetailModal =  false;
        },
        closeComputerEaseConnectionDetailModal() {
            this.computerEaseConnectionDetailModal =  false;
        },
        saveFoundationConnectionDetail() {
            let self = this;
            self.foundationSyncLoader = true;
            axios.post(route('api.erp-integration.add.update.foundation.connection.detail'), self.foundationConnectionDetail)
                .then((response) => {
                    self.foundationSyncLoader = false;
                    if(response.data.status) {
                        self.getToast(3000).fire({
                            type: 'success',
                            title: 'Foundation connection details updated successfully.'
                        });
                        self.closeFoundationConnectionDetailModal();
                        // self.syncFoundationData();
                    }
                    else {
                        self.getToast(3000).fire({
                            type: 'error',
                            title: 'Incorrect credentials entered!'
                        });
                    }
                })
                .catch((error) => {
                    self.foundationSyncLoader = false;
                    let vErrors = Object.values(error.response.data.errors).map((val) => {
                        return val[0];
                    });
                    if(vErrors.length > 0) {
                        this.getToast(3000).fire({
                            type: 'error',
                            title: vErrors[0]
                        });
                    }
                    else {
                        self.getToast(3000).fire({
                            type: 'error',
                            title: 'Some error occurred!'
                        });
                    }
                });
        },

        saveSageIntacctConnectionDetail() {
            let self = this;
            self.foundationSyncLoader = true;
            axios.post(route('api.erp-integration.add.update.sage-intacct.connection.detail'), self.sageIntacctConnectionDetail)
                .then((response) => {
                    self.foundationSyncLoader = false;
                    if(response.data.status) {
                        self.getAllErp();
                        self.getToast(3000).fire({
                            type: 'success',
                            title: 'Sage Intacct connection details updated successfully. Please Select the Loaction.!'
                        });
                        self.closeSageIntacctConnectionDetailModal();
                    }
                    else {
                        self.getToast(3000).fire({
                            type: 'error',
                            title: 'Incorrect credentials entered!'
                        });
                    }
                })
                .catch((error) => {
                    self.foundationSyncLoader = false;
                    let vErrors = Object.values(error.response.data.errors).map((val) => {
                        return val[0];
                    });
                    if(vErrors.length > 0) {
                        this.getToast(3000).fire({
                            type: 'error',
                            title: vErrors[0]
                        });
                    }
                    else {
                        self.getToast(3000).fire({
                            type: 'error',
                            title: 'Some error occurred!'
                        });
                    }
                });
        },
        saveComputerEaseConnectionDetail() {
            let self = this;
            self.foundationSyncLoader = true;
            if(!self.computerEaseConnectionDetail.api_key){
                self.getToast(3000).fire({
                    type: 'error',
                    title: 'API Key is required!'
                });
                return false;
            }else if(!self.computerEaseConnectionDetail.refresh_token){
                self.getToast(3000).fire({
                    type: 'error',
                    title: 'Refresh Token is required!'
                });
                return false;
            }
            axios.post(route('api.erp-integration.add-computerEase-details'), this.computerEaseConnectionDetail)
                .then((response) => {
                    self.foundationSyncLoader = false;
                    if(response.data.status == 'success') {
                        self.getAllErp();
                        self.getToast(3000).fire({
                            type: 'success',
                            title: 'Computer Ease API Key updated successfully.'
                        });
                        self.closeComputerEaseConnectionDetailModal();
                    }
                    else {
                        self.getToast(3000).fire({
                            type: 'error',
                            title: 'Something went wrong!'
                        });
                    }
                })
                .catch((error) => {
                    self.foundationSyncLoader = false;
                    self.getToast(3000).fire({
                        type: 'error',
                        title: 'Something went wrong!'
                    });
                });
        },

        changeSageIntacctLocation(event){
            let self = this;
            axios.post(route('api.erp-integration.add.update.sage-intacct.location'), {'sage_intacct_location_id': self.sage_intacct_location_id})
                .then((response) => {
                    if(response.data.status) {
                        self.getToast(3000).fire({
                            type: 'success',
                            title: 'Sage Intacct location updated successfully.'
                        });
                        self.closeSageIntacctConnectionDetailModal();
                    }
                    else {
                        self.getToast(3000).fire({
                            type: 'error',
                            title: 'Sage Intacct location updated failed'
                        });
                    }
                })
                .catch((error) => {
                    self.getToast(3000).fire({
                        type: 'error',
                        title: 'Some error occurred!'
                    });
                });
        },

        syncFoundationData() {
            let self = this;
            let payload =  {
                erpIntegrationId : self.erpIntegrationId
            };
            axios.post(route('api.erp-integration.foundation.sync'), payload).then(({data}) => {
                if(self.syncFoundationContractMsg()) {
                    self.contractMsg = data.message;
                }
                self.showSyncModal =  true;
            }).catch((error) => {
                self.showSyncModal =  true;
            });
        },
        syncFoundationContractMsg() {
            let self = this;
            let mapData = _.find(self.mappingData, function(data) { return (data.followUp === 'Project' && data.status === true) });
            if(self.direction !== 'one-way-followup' && mapData !== null && mapData !== undefined) {
                return true;
            }
            return false;
        },
        closeImportModal() {
            this.showImportModal = false;
        },
        importFoundationData() {
            let self = this;
            let payload =  {
                erpIntegrationId : self.erpIntegrationId
            };
            Swal.fire({
                title: 'Import From Foundation',
                text: "This will import all customers from Foundation to FollowUp",
                type: 'info',
                showCancelButton: true,
                confirmButtonColor: '#01B1AF',
                confirmButtonText: 'Confirm'
            }).then((result) => {
                if (result.value) {
                    self.importModalMsg = 'Customers Import in Progress';
                    self.importModalTitle = 'Data Import';
                    self.showImportModal =  true;
                    axios.post(route('api.erp-integration.foundation.import'), payload).then(({data}) => {
                    }).catch((error) => {
                        //
                    });
                }
            });
        },
        exportDataToFoundation() {
            return false;
            let self = this;
            let payload =  {
                erpIntegrationId : self.erpIntegrationId
            };

            Swal.fire({
                title: 'Export to Foundation',
                text: "This will push all projects from FollowUp with the status “Contract” to Foundation as Jobs",
                type: 'info',
                showCancelButton: true,
                confirmButtonColor: '#01B1AF',
                confirmButtonText: 'Confirm'
            }).then((result) => {
                if (result.value) {
                    self.importModalMsg = 'Projects Export in Progress';
                    self.importModalTitle = 'Data Export';
                    self.showImportModal =  true;
                    axios.post(route('api.erp-integration.foundation.export'), payload).then(({data}) => {
                    }).catch((error) => {
                        //
                    });
                }
            });
        },
        generateVistaLinkToken(){
            this.connectionLoadingOverlay = true;
            axios.post(route('api.erp-integration.agave.linkToken')).then((response) => {
                    this.selectAgaveService(response.data.link_token);
            });
        },
        selectAgaveService(linkToken){
            this.connectionLoadingOverlay = false;
            window.AgaveLink.openLink({
                linkToken: linkToken,
                showSandboxSourceSystems: true,

                onSuccess: (public_token) => {
                    this.generateAccountTokenWithPublicTokenAgave(public_token);
                },

                onExit: (error) => {
                    console.error(error)
                }
            });
        },
        generateAccountTokenWithPublicTokenAgave(public_token){
            axios.post(route('api.erp-integration.agave.accountToken'), {publicToken: public_token, integrationType: this.modelName}).then((response) => {
                console.log("erp-integration.agave.accountToken response", response)
                if(response.data.status == 'success'){
                    this.getToast().fire({
                        type: 'success',
                        title: response.data.message
                    });
                    window.location.reload();
                }else{
                    this.getToast().fire({
                        type: 'error',
                        title: response.data.message
                    });
                }
            });
        },
        backToERPConnection(){
            this.showErpConnect = true;
            this.$nextTick(() => {
                $('.custom-tooltip').tooltip('dispose');
                $('.custom-tooltip').tooltip({
                    trigger: 'hover',
                    placement: 'top',
                    container: 'body'
                });
            });

        }
    }
}
</script>
<style>
.connection-loading-overlay{
    position: fixed;
    display: block;
    width: 100%;
    height: 100%;
    top:18px;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
    cursor: pointer;
    background: #ffffffd9;
}
</style>
